import React from 'react';

import PropTypes from 'prop-types';
import { Header, Table } from 'semantic-ui-react';

import _isEmpty from 'lodash/isEmpty';

import CustomerSubmissionsModalTableRow from './CustomerSubmissionsModalTableRow';

const propTypes = {
  headerText: PropTypes.string.isRequired,
  data: PropTypes.shape({}).isRequired,
};

const defaultProps = {};

export default function CustomerSubmissionsModalTable({ headerText, data }) {
  if (_isEmpty(data)) {
    return null;
  }

  return (
    <>
      {headerText && <Header as="h2">{headerText}</Header>}
      <Table celled striped>
        <Table.Body>
          {data.map(({ name, label, value, inputType, widgetType }) => {
            return (
              <CustomerSubmissionsModalTableRow
                fieldName={name}
                fieldLabel={label}
                fieldValue={value}
                inputType={inputType}
                widgetType={widgetType}
              />
            );
          })}
        </Table.Body>
      </Table>
    </>
  );
}

CustomerSubmissionsModalTable.propTypes = propTypes;
CustomerSubmissionsModalTable.defaultProps = defaultProps;
